<template>
  <div>
    <portal to="back">
      <v-btn icon @click="$router.push('../../'+$router.currentRoute.params.type+'/')">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
    </portal>
    <portal to="title">
      <v-progress-circular v-if="title==null" indeterminate size="20" width="3" class="mt-n1"/>
      <span>{{title}} ({{userType}})</span>
    </portal>
    <page-tabs
        :tabs="tabs[$router.currentRoute.params.type]"
        :tabSelected.sync="tabSelected"
    >
    <template v-slot:default="{tabSelected}">
        <div v-if="$router.currentRoute.params.type==='client'">
          <UserProfile v-if="tabSelected==='UserProfile'"/>
          <ClientVisits v-if="tabSelected==='ClientVisits'" :visitsUnpayed.sync="visitsUnpayed"/>
          <ClientCallGroups v-if="tabSelected==='ClientCallGroups'" :userId="$route.params.id" :userPhone="phone"/>
          <ClientVisitPlans v-if="tabSelected==='ClientVisitPlans'" :visitPlans="visitPlans" :visitPlanLoadState="visitPlanLoadState" @visit-plans-load="visitPlansLoad()" />
          <ClientPays v-if="tabSelected==='ClientPays'" @visitsUnpayed="visitsUnpayed=true"/>
          <ClientMedPlansVisitServices v-if="tabSelected==='ClientMedPlansVisitServices'"/>
          <ClientMedRecords v-if="tabSelected==='ClientMedRecords'" :userName="title"/>
          <ClientMedias v-if="tabSelected==='ClientMedias'" :userName="title"/>
          <ClientFamily v-if="tabSelected==='ClientFamily'"/>
          <UserNotifs v-if="tabSelected==='UserNotifs'"/>
        </div>

        <div v-if="$router.currentRoute.params.type==='spec'">
          <UserProfile v-if="tabSelected==='UserProfile'"/>
          <UserSpec v-if="tabSelected==='UserSpec'"/>
          <UserServices v-if="tabSelected==='UserServices'"/>
          <UserSalary v-if="tabSelected==='UserSalary'"/>
          <UserNotifs v-if="tabSelected==='UserNotifs'"/>
          <ClientCallGroups v-if="tabSelected==='ClientCallGroups'" :userId="$route.params.id"/>
        </div>

        <div v-if="$router.currentRoute.params.type==='admin'">
          <UserProfile v-if="tabSelected==='UserProfile'"/>
          <UserSpec v-if="tabSelected==='UserSpec'"/>
          <UserSalary v-if="tabSelected==='UserSalary'"/>
          <UserNotifs v-if="tabSelected==='UserNotifs'"/>
          <ClientCallGroups v-if="tabSelected==='ClientCallGroups'" :userId="$route.params.id"/>
        </div>
    </template>
    </page-tabs>


  </div>
</template>

<script>
import PageTabs from "@/componentsV2/base/PageTabs.vue";
import ClientVisits from "@/views/User/Client/ClientVisits";
import ClientVisitPlans from "@/views/User/Client/ClientVisitPlans";
import ClientPays from "@/views/User/Client/ClientPays";
import ClientMedPlansVisitServices from "@/views/User/Client/ClientMedPlansVisitServices";
import ClientMedRecords from "@/views/User/Client/ClientMedRecords";
import ClientMedias from "@/views/User/Client/ClientMedias";
import ClientFamily from "@/views/User/Client/ClientFamily";
import UserProfile from "@/views/User/UserProfile";
import UserServices from "@/views/User/UserServices";
import axios from "axios";
import UserSpec from "@/views/User/UserSpec";
import UserSalary from "@/views/User/UserSalary";
import State from "@/plugins/state";
import UserNotifs from "@/views/User/UserNotifs.vue";
import ClientCallGroups from "@/views/User/Client/ClientCallGroups";
import {
  Entity_User, 
  Entity_UserSpec,
  Entity_Spec, 
  Entity_VisitPlan,
  Entity_ComDiv,
  Entity_ComBranch
} from "../../../EntityStoreCacheService";

export default {
  components: {
    PageTabs,
    UserNotifs,
    UserSpec,
    UserProfile,
    ClientFamily,
    ClientMedias,
    ClientMedRecords,
    ClientMedPlansVisitServices,
    ClientPays,
    ClientVisits,
    UserServices,
    UserSalary,
    ClientVisitPlans,
    ClientCallGroups
  },
  data:()=>({
    tabSelected: null,
    tabs: {
      client: [
        { name: 'UserProfile', perm: 'usersClientProfile', icon: 'mdi-card-account-details', label: 'Профиль' },
        { name: 'ClientVisits', perm: 'usersClientVisit', icon: 'mdi-calendar', label: 'Визиты' },
        { name: 'ClientCallGroups', perm: 'usersClientCall', icon: 'mdi-phone-clock', label: 'История звонков' },
        { name: 'ClientVisitPlans', perm: 'usersClientVisitPlan', icon: 'mdi-calendar-question', label: 'Лист ожидания', labelComputed: true },
        { name: 'ClientPays', perm: 'usersClientPay', icon: 'mdi-cash', label: 'Личный счет и платежи' },
        { name: 'ClientMedPlansVisitServices', perm: 'usersClientMedplan', icon: 'mdi-text-box', label: 'Планы лечения и услуги' },
        { name: 'ClientMedRecords', perm: 'usersClientMedcard', icon: 'mdi-clipboard-text', label: 'Мед. карта' },
        { name: 'ClientMedias', perm: 'usersClientDoc', icon: 'mdi-file-document', label: 'Документы' },
        { name: 'ClientFamily', perm: 'usersClientFamily', icon: 'mdi-account-group', label: 'Семья' },
        { name: 'UserNotifs', perm: 'usersClientNotif', icon: 'mdi-bell', label: 'Оповещения' }
      ],
      spec: [
        { name: 'UserProfile', perm: 'usersSpecProfile', icon: 'mdi-card-account-details', label: 'Профиль' },
        { name: 'UserSpec', perm: 'usersSpecSpec', icon: 'mdi-doctor', label: 'Специализации' },
        { name: 'UserServices', perm: 'usersSpecService', icon: 'mdi-currency-rub', label: 'Услуги' },
        { name: 'UserSalary', perm: 'usersSpecSalary', icon: 'mdi-account-cash', label: 'Расчёт Зарплаты' },
        { name: 'UserNotifs', perm: 'usersSpecNotif', icon: 'mdi-bell', label: 'Оповещения' },
        { name: 'ClientCallGroups', perm: 'usersSpecCall', icon: 'mdi-phone-clock', label: 'История звонков' }
      ],
      admin: [
        { name: 'UserProfile', perm: 'usersAdminProfile', icon: 'mdi-card-account-details', label: 'Профиль' },
        { name: 'UserSpec', perm: 'usersAdminSpec', icon: 'mdi-doctor', label: 'Специализации' },
        { name: 'UserSalary', perm: 'usersAdminSalary', icon: 'mdi-account-cash', label: 'Расчёт Зарплаты' },
        { name: 'UserNotifs', perm: 'usersAdminNotif', icon: 'mdi-bell', label: 'Оповещения' },
        { name: 'ClientCallGroups', perm: 'usersAdminCall', icon: 'mdi-phone-clock', label: 'История звонков' }
      ]
    },
    title:null,
    phone:null,
    visitsUnpayed:false,
    userType:null,
    
    visitPlanLoadState: new State(),
    visitPlans:[],
    visitPlansAmount: 0,
  }),
  watch:{
    visitsUnpayed(){
      if(this.visitsUnpayed)
        this.tabSelected = 'ClientVisits';
    }
  },
  mounted(){
    axios.get('/api/user/'+this.$route.params.id+'/')
      .then((r)=> {
    
        this.title = '';
        this.title += r.data.lastName != null ? r.data.lastName + ' ' : '';
        this.title += r.data.firstName != null ? r.data.firstName + ' ' : '';
        this.title += r.data.secondName != null ? r.data.secondName + ' ' : '';

        this.phone = r.data.phone;

        if(this.$router.currentRoute.params.type==='client') {
          this.userType = 'Клиент'
          this.visitPlansLoad();
        }

        if(this.$router.currentRoute.params.type==='spec') {
          this.userType = 'Специалист'
        }

        if(this.$router.currentRoute.params.type==='admin') {
          this.userType = 'Администратор'
        }

        if(window.location.hash==='#media_medCard')
          this.tabSelected = 'ClientMedRecords';

        if(window.location.hash==='#media_documents')
          this.tabSelected = 'ClientMedias';
      })
      .catch((error)=> {
        console.log(error)
      });
  },
  methods:{
    visitPlansLoad(){
      let rb = new Entity_VisitPlan()
      .selects(Entity_VisitPlan.id)
      .selects(Entity_VisitPlan.begin)
      .selects(Entity_VisitPlan.comment)
      .selects(Entity_VisitPlan.isLiveList)

      //spec
      .selects([Entity_VisitPlan.spec, Entity_Spec.id].join('.'))
      .selects([Entity_VisitPlan.spec, Entity_Spec.name].join('.'))

      //user
      .selects([Entity_VisitPlan.user, Entity_User.id].join('.'))
      .selects([Entity_VisitPlan.user, Entity_User.firstName].join('.'))
      .selects([Entity_VisitPlan.user, Entity_User.secondName].join('.'))
      .selects([Entity_VisitPlan.user, Entity_User.lastName].join('.'))
      .selects([Entity_VisitPlan.user, Entity_User.phone].join('.'))
      
      //userSpec
      .selects([Entity_VisitPlan.userSpec, Entity_UserSpec.id].join('.'))
      .selects([Entity_VisitPlan.userSpec, Entity_UserSpec.spec, Entity_Spec.id].join('.'))
      .selects([Entity_VisitPlan.userSpec, Entity_UserSpec.spec, Entity_Spec.name].join('.'))
      .selects([Entity_VisitPlan.userSpec, Entity_UserSpec.commentAdmin].join('.'))
      .selects([Entity_VisitPlan.userSpec, Entity_UserSpec.comDiv, Entity_ComDiv.comBranch, Entity_ComBranch.id].join('.'))
      .selects([Entity_VisitPlan.userSpec, Entity_UserSpec.comDiv, Entity_ComDiv.comBranch, Entity_ComBranch.name].join('.'))
      .selects([Entity_VisitPlan.userSpec, Entity_UserSpec.user, Entity_User.id].join('.'))
      .selects([Entity_VisitPlan.userSpec, Entity_UserSpec.user, Entity_User.firstName].join('.'))
      .selects([Entity_VisitPlan.userSpec, Entity_UserSpec.user, Entity_User.secondName].join('.'))
      .selects([Entity_VisitPlan.userSpec, Entity_UserSpec.user, Entity_User.lastName].join('.'))
      .selects([Entity_VisitPlan.userSpec, Entity_UserSpec.user, Entity_User.imageUrl].join('.'))

      // filter liveList
      rb.filterAnd([Entity_VisitPlan.entity, Entity_VisitPlan.isLiveList].join('.')+'=?',0);  

      //filter by user
      rb.filterAnd([Entity_VisitPlan.entity, Entity_VisitPlan.user, Entity_User.id].join('.')+' =?',this.$route.params.id);
      
      rb.order([Entity_VisitPlan.begin].join('.'), true)

      rb.page(1).onPage(1000)
      rb.addStateCallback((v)=> this.visitPlanLoadState.setRequestBuilderState(v))
      .request((v)=>{
          this.visitPlans = v.items;
          this.visitPlansAmount = v.count;
      }, (e)=>{
        console.error(e.response.data.message);
      })
    },
  },
  
}
</script>